/**
 * TASK-990 — Pricing and the Voice modal show catalog retail, including the
 * shop_retail_comp shop. The $0 charge stays on the Stripe session (TASK-824).
 */

export function dueMonthly(amount, _retailComp) {
  const n = parseFloat(amount);
  return Number.isFinite(n) ? n : 0;
}

export function formatDueMonthly(amount, retailComp) {
  return dueMonthly(amount, retailComp).toFixed(2);
}
